import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AppContext } from '../../contexts/AppContext';
import { OemIndirect, PriceListItem } from '../../models/ApiModels';

type InfoProps = {
  newIndirectOem?: OemIndirect;
  handleChange: (e: any) => void;
  handlePriceChange: (item: any, index: any) => void;
  indirectOem?: OemIndirect;
  editMode?: boolean;
};

function FunctionPackagesPrices({ newIndirectOem, handleChange, handlePriceChange, indirectOem, editMode }: InfoProps) {
  const { currentOem } = useContext(AppContext);
  const packages = useSelector((state: any) => state.configurations.packages);
  const oem = newIndirectOem || indirectOem || (currentOem as any);

  return (
    <div>
      <div className='flex gap-2 items-center py-3 border-y border-gray-3 mb-4'>
        <span className='prose-paragraphBase'>Currency</span>
        <div className='ml-auto'>
          {newIndirectOem || editMode ? (
            <input
              className='bg-gray-3 px-3 h-10 prose-paragraphTiny'
              type='text'
              name='currencyCode'
              placeholder='Enter display currency...'
              value={oem?.currencyCode}
              onChange={handleChange}
              maxLength={3}
            />
          ) : (
            <div>{oem?.currencyCode}</div>
          )}
        </div>
      </div>
      <div className=''>
        <div className='hidden xl:flex bg-gray-5 py-2 xl:px-5 mb-1 prose-mainMenuL2Default'>Manual</div>
        {oem?.settings.priceList?.slice(0, 6).map((item: PriceListItem, index: number) => {
          return (
            <div
              className='xl:flex justify-between border-b border-gray-10 py-2 xl:py-6 xl:px-5 my-1 items-center gap-2'
              key={item.internalId}
            >
              <label className='prose-mainMenuL2Default min-w-max'>
                {packages.find((pack: any) => pack.id === item.internalId)?.displayName || 'Underwater Lights'}
              </label>

              <div className='flex gap-2 justify-end items-center w-full'>
                {newIndirectOem || editMode ? (
                  <input
                    className='xl:w-40 w-full bg-gray-3 px-3 h-10 prose-paragraphTiny'
                    type='number'
                    placeholder='Enter price input...'
                    value={item.unitPrice || ''}
                    onChange={(e) => handlePriceChange(index, Number(e.target.value))}
                  />
                ) : (
                  <span className='w-full xl:px-3 h-10 flex items-center xl:justify-end font-bold'>
                    {item.unitPrice}
                  </span>
                )}
                <div className='font-bold prose-heading5 min-w-[3rem] text-right'>{oem?.currencyCode}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default FunctionPackagesPrices;
